import { Button, Typography, Box, IconButton, Card, Stack } from "@mui/material";
import React from "react";
import { Add, AddCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useGetClientsQuery } from "../../apis/clients";
import ClientCard from "../../components/Client/ClientCard";

const Clients = () => {
  const { data: clients } = useGetClientsQuery();
  const navigate = useNavigate();
  const handleClick = () => navigate("./register");

  return (
    <Stack spacing={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h4">My Clients</Typography>
          <Typography variant="body2" color="GrayText">
            you can create up to 5 clients
          </Typography>
        </Box>
        <Button variant="contained" onClick={handleClick} startIcon={<Add />} size="large">
          Create New Client
        </Button>
      </Box>

      {clients?.length ? (
        clients?.map((client, index) => (
          <ClientCard index={index} client={client} key={client.id} />
        ))
      ) : (
        <Card sx={{ textAlign: "center", p: 2 }}>
          <IconButton color="primary" onClick={handleClick}>
            <AddCircle />
          </IconButton>
        </Card>
      )}
    </Stack>
  );
};

export default Clients;
